import type { RenderCellProps } from 'components/DataGrid';
import type { GridRow } from '../../types';
import { ReactNode } from 'react';
import { InvoiceBoundState } from 'modules/invoicing/common/components';
import { Box } from '@ff-it/ui';
import { MoneyCell } from 'components/MoneyCell';
import { DeltaBadge } from './DeltaBadge';

export function View({ row, month }: RenderCellProps<GridRow, any> & { month: string }): ReactNode {
  const monthSum = row.months[month];
  if (!monthSum) {
    // HACK:  Never empty for delivery cell
    return ' ';
  }

  const {
    target_client_net_total: target_income,
    planned_client_net_total: planned_income,
    income_state,
    target_provider_net_total: target_expense,
    planned_provider_net_total: planned_expense,
    expense_state,
  } = monthSum;

  return (
    <>
      <Box display="flex" flexDirection="row" alignItems="center" lineHeight="xs" fontSize="xs">
        <InvoiceBoundState direction="CLIENT" state={income_state} />
        {planned_income !== target_income && (
          <DeltaBadge testId="planned_income" planned={planned_income} target={target_income} />
        )}
        <MoneyCell data-testid="target_income" value={target_income} ml="auto" />
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center" lineHeight="xs" fontSize="xs">
        <InvoiceBoundState direction="AGENCY" state={expense_state} />
        {planned_expense !== target_expense && (
          <DeltaBadge testId="planned_expense" planned={planned_expense} target={target_expense} />
        )}
        <MoneyCell data-testid="target_expense" value={target_expense} ml="auto" />
      </Box>
    </>
  );
}
